export const INVENTORY_FIELDS = `
  fragment InventoryFields on Inventory {
    id
    productId
    name
    schema
    description
    type
    priceCents
    shippingCents
    benefits
    skuCode
    level
    isVip
  }
`
